export * from './equipments.service';
